import { render, staticRenderFns } from "./OrgItemCreate.vue?vue&type=template&id=aaab7926"
import script from "./OrgItemCreate.vue?vue&type=script&lang=js"
export * from "./OrgItemCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports